import { type FC } from 'react';
import { BaseEdge, getBezierPath, type EdgeProps } from 'reactflow';
import type { LinkData } from '@/types/link.types';

const CONTRIBUTION_COLOR = '#22C55E';

export const ContributionEdge: FC<EdgeProps<LinkData>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
}) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      markerEnd={markerEnd}
      style={{
        stroke: CONTRIBUTION_COLOR,
        strokeWidth: 2,
        ...style,
      }}
    />
  );
};

export default ContributionEdge;
